import ItemsCollection, {Item} from './ItemsCollection';

import Axios from 'axios';
import Module from './Module';
import axiosInstance from '@/helpers/axios';
import stores from '@/stores/index';
import {generateLog} from '@/helpers/functions';

const CancelToken: any = Axios.CancelToken;
let cancel: any;

export class WebsiteApplicationsModuleItem extends Item implements IApplicationsCategory {
  moduleId!: number | null;
  name!: string;
  active!: boolean;
  description!: string | null;
  children!: any[];
  parentId!: number | null;
  sort!: number;
  slug!: string | null;
  imageId!: number | null;
}

export class WebsiteApplicationsItemsCollection extends ItemsCollection<WebsiteApplicationsModuleItem> {
  model() {
    return WebsiteApplicationsModuleItem;
  }

  url(): string {
    return this.module.url();
  }

}

export default class ApplicationsModule extends Module<WebsiteApplicationsItemsCollection> {

  routeName = 'website_applications';

  Collection() {
    return WebsiteApplicationsItemsCollection;
  }

  url() {
    return `/applications/${this.id}`;
  }

  urlItem() {
    return `${this.url()}/application`;
  }

  urlCategory() {
    return `${this.url()}/categories`;
  }

  urlItems() {
    return `${this.url()}/application`;
  }

  updateCategory(id: any, category: ICategories) {
    return axiosInstance.patch(`${this.urlCategory()}/${id}`, category)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Applications',
          message: e,
        };
        generateLog(log);
      });
  }

  getAllCategories(search: string | null = null) {
    if (cancel !== undefined) {
      cancel();
    }
    const searchString = (Boolean(search)) ? `search=${search}` : '';
    return axiosInstance.get(`${this.urlCategory()}?${searchString}`, {
      cancelToken: new CancelToken(function executor(c: any) {
        cancel = c;
      }),
    })
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Applications',
          message: e,
        };
        generateLog(log);
      });
  }

  fetchData(index: number = 1, search: string | null, perpage: number | null) {
    if (cancel !== undefined) {
      cancel();
    }

    if (Boolean(search)) {
      return axiosInstance.get(`${this.urlItems()}?search=${search}`, { cancelToken: new CancelToken(function executor(c: any) {cancel = c; })})
        .then((response) => response.data).catch((e) => {
          const log: any = {
            route: 'Applications',
            message: e,
          };
          generateLog(log);
        });
    } else { return axiosInstance.get(`${this.urlItems()}?page=${index}&perpage=${perpage}`, { cancelToken: new CancelToken(function executor(c: any) { cancel = c; })})
        .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Applications',
          message: e,
        };
        generateLog(log);
      });
    }
  }

  createNewItem(item: any) {
    return axiosInstance.post(`${this.urlItem()}`, item)
      .then((response) => {
        return response.data;
      }).catch((e) => {
        const log: any = {
          route: 'Applications',
          message: e,
        };
        generateLog(log);
      });
  }

  detachCategoryFromPage(application: IApplicationsItem, n: any) {
    return axiosInstance.post(`${this.urlItem()}/${application.id}/detach`, {name: n.tag.text})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Applications',
          message: e,
        };
        generateLog(log);
      });
  }

  attachCategoryToPage(application: IApplicationsItem, n: any) {
    return axiosInstance.post(`${this.urlItem()}/${application.id}/attach`, {name: n.tag.text})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Applications',
          message: e,
        };
        generateLog(log);
      });
  }

  getAutocompleteCategories(query: string, source: any) {
    return axiosInstance.get(`${this.urlCategory()}/unattached?query=${query}`, {cancelToken: source.token})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Applications',
          message: e,
        };
        generateLog(log);
      });
  }

  deleteItem(id: number) {
    return axiosInstance.delete(`${this.urlItem()}/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Applications',
          message: e,
        };
        generateLog(log);
      });
  }

  deleteItems(ids: any[]) {
    return axiosInstance.post(`${this.urlItem()}/delete`, {ids})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Applications',
          message: e,
        };
        generateLog(log);
      });
  }

  updateItem(id: number, application: IApplicationsItem) {
    return axiosInstance.put(`${this.urlItem()}/${id}`, application)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Applications',
          message: e,
        };
        generateLog(log);
      });
  }

  getApplicationDetails(id: number) {
    return axiosInstance.get(`${this.urlItem()}/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Applications',
          message: e,
        };
        generateLog(log);
      });
  }

  createNewCategory(cat: IApplicationsCategory, id: string) {
    return axiosInstance.post(`${this.urlCategory()}`, {category: cat})
      .then((response) => {
        return response.data;
      }).catch((e) => {
        const log: any = {
          route: 'Applications',
          message: e,
        };
        generateLog(log);
      });
  }

  deleteCategory(id: number) {
    return axiosInstance.delete(`${this.urlCategory()}/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Applications',
          message: e,
        };
        generateLog(log);
      });
  }

  sortCategories(id: number, newPosition: number) {
    return axiosInstance.patch(`${this.urlCategory()}/${id}/resort`, {sort: newPosition})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Applications',
          message: e,
        };
        generateLog(log);
      });
  }

  sortMovies(id: number, newPosition: number) {
    return axiosInstance.patch(`${this.urlItem()}/${id}/resort`, {sort: newPosition})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Applications',
          message: e,
        };
        generateLog(log);
      });
  }

  getCatalogueCategories() {
    return axiosInstance.get(this.urlCategory())
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Applications',
          message: e,
        };
        generateLog(log);
      });
  }

  editCatalogueCategory(cat: IApplicationsCategory) {
    return axiosInstance.put(`${this.urlCategory()}/${cat.id}`, cat)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Applications',
          message: e,
        };
        generateLog(log);
      });
  }

  getSpecificCategory(id: number) {
    return axiosInstance.get(`${this.urlCategory()}/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'Applications',
          message: e,
        };
        generateLog(log);
      });
  }

}

export class WebsiteApplicationsItem extends Item implements IApplicationsItem {
  moduleId!: number;
  name!: '';
  imageId!: null;
  content!: string;
  active!: boolean;
  categories!: ICategories[];
  parentId!: null;
  shortDescription!: string | null;
  description!: string;
  sort!: 0;
  showDescription!: boolean | false;
  packageName!: string | null;
  tokenLge!: string | null;

  url() {
    return `/applications/${this.id}`;
  }

  urlItem() {
    return `${this.url()}/application`;
  }

}
